<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item
      v-for="shipment in shipments"
      :key="shipment.id"
      :name="shipment.id"
    >
      <template slot="title">
        <span>
          <span v-if="shipment.name">
            {{ shipment.name }}<span v-if="shipment.tracking_number"> ({{ shipment.tracking_number }})</span>
          </span>
          <span v-else-if="shipment.tracking_number">
            {{ shipment.tracking_number }}
          </span>
          <span v-else>
            Expédition
          </span>
          <el-tag style="margin-left: 8px;">{{ $t("ELIXIO_CONNECT.SHIPMENT_STATUS_"+shipment.status) }}</el-tag>
        </span>
      </template>

      <shipment-item
        :shipment="shipment"
        @updated="$emit('updated')"
      />
    </el-collapse-item>
  </el-collapse>
</template>

<script>

import {
  Collapse,
  CollapseItem,
  Tag
} from "element-ui";


import ShipmentItem from "./ShipmentItem.vue";

export default {
  name: "ShipmentList",
  components: { 
    ShipmentItem,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tag.name]: Tag,
  },
  props: {
    shipments: { type: Array, default: () => [] }
  },
  data() {
    return {
      activeNames: []
    };
  },
  mounted() {
    if (this.shipments.length) {
      this.activeNames = [this.shipments[0].id]; // ouvrir le plus récent
    }
  }
};
</script>
